import caller from "../../helpers/caller";

/** payload: { customerId, type: "APOSENTADORIA" | "PENSAO", answers: {...} } */
export default async function putInsertCustomerQuestionnaire(api, payload) {
  return await caller(api.put, "/customer_questionnaire/insert", payload);
}
